<h2 mat-dialog-title>{{ 'DELETE_KNOWLEDGE.TITLE' | translate }}</h2>
<mat-dialog-content>
  <ai-knowledge-apps-for-knowledge-source
    [knowledgeSourceId]="data.knowledgeSourceId"
  ></ai-knowledge-apps-for-knowledge-source>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-stroked-button (click)="cancel()">{{ 'COMMON.CANCEL' | translate }}</button>
  <button mat-flat-button color="warn" (click)="delete()">{{ 'COMMON.DELETE' | translate }}</button>
</mat-dialog-actions>
